// 게임 설정 상수들
const GameConfig = {
  // 렌더러 설정
  RENDERER: {
    ANTIALIAS: true,
    SHADOW_MAP_TYPE: THREE.PCFSoftShadowMap,
    OUTPUT_COLOR_SPACE: THREE.SRGBColorSpace,
    TONE_MAPPING: THREE.ACESFilmicToneMapping,
    TONE_MAPPING_EXPOSURE: 1.0,
  },

  // 카메라 설정
  CAMERA: {
    VIEW_SIZE: 15,
    POSITION: { x: 0, y: 15, z: 15 },
    LOOK_AT: { x: 0, y: 0, z: 0 },
    NEAR: 0.1,
    FAR: 1000,
    // 한국어 주석: 업그레이드 연출용 카메라 줌 설정 (동료 소환/용사 업그레이드 등)
    ZOOM: {
      ON_COMPANION_SPAWN: {
        ENABLED: true, // 동료 소환 시 카메라 줌 연출 사용 여부
        SCALE: 1.1, // 줌 배율 (값이 클수록 더 가까이)
        DURATION: 0.5, // 유지 시간 (초)
      },
      ON_KNIGHT_UPGRADE: {
        ENABLED: true, // 용사 업그레이드 시 카메라 줌 연출 사용 여부
        SCALE: 1.1,
        DURATION: 0.5,
      },
    },
    // 한국어 주석: 회전 연출 설정 (플레이어 사망 시 사용)
    ROTATION: {
      ON_PLAYER_DEATH: {
        ENABLED: true,
        DURATION: 1.5,
      },
    },
  },

  // 씬 설정
  SCENE: {
    BACKGROUND_COLOR: 0x87ceeb, // 하늘색
  },

  // 레벨 시스템 설정 (뱀파이어 서바이벌 스타일)
  LEVEL_SYSTEM: {
    STARTING_LEVEL: 1, // 시작 레벨
    STARTING_EXP: 0, // 시작 경험치
    EXP_PER_LEVEL: 80, // 레벨당 필요 경험치 (기본값)
    EXP_SCALING: 1.2, // 레벨이 올라갈수록 필요 경험치 증가 배율
    MAX_LEVEL: 1000, // 최대 레벨
  },

  // 입력 설정
  INPUT: {
    MOVEMENT_KEYS: {
      KeyW: "w",
      KeyA: "a",
      KeyS: "s",
      KeyD: "d",
    },
  },

  // 디버그 설정
  DEBUG: {
    ENABLED: false, // 배포용: false
    LOG_LEVEL: "error", // info, warn, error
    UI_LOG_ENABLED: false, // 한국어 주석: 화면에 로그 표시 여부 (배포 기본값: 비활성화)
  },
};

// 환경별 설정 오버라이드
const Environment = {
  development: {
    DEBUG: {
      ENABLED: true,
      LOG_LEVEL: "info",
      UI_LOG_ENABLED: true,
    },
  },
  production: {
    DEBUG: {
      ENABLED: false,
      LOG_LEVEL: "error",
      UI_LOG_ENABLED: false,
    },
  },
};

// 현재 환경 감지 (개발환경은 localhost 또는 file 프로토콜)
const getCurrentEnvironment = () => {
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.protocol === "file:";
  return isLocal ? "development" : "production";
};

// 환경별 설정 적용
const currentEnv = getCurrentEnvironment();
if (Environment[currentEnv]) {
  Object.assign(GameConfig.DEBUG, Environment[currentEnv].DEBUG);
}

// webpack 빌드를 위해 default export 추가
export default GameConfig;

// 전역 변수로도 등록 (기존 코드 호환성)
window.GameConfig = GameConfig;
